// Copy this file to hassioConfig.js and fill in your values.
// Ensure hassioConfig.js is in .gitignore.

export const HASS_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI3ZmJhZTgzOTI5ZGU0OTBhODRiNjJmNTM0ZjUwYzFlNyIsImlhdCI6MTc1NTEyMjg0NiwiZXhwIjoyMDcwNDgyODQ2fQ.nBIrp67USAYAR8KaQbQbjl7btfss-gMauSqKFKRoFr0';
export const HASS_HOST = 'http://192.168.86.148:8123';
